import {
  HIDE_PAGE_DATOS_FACTURACION,
  SHOW_PAGE_DATOS_FACTURACION,
  DatosFacturacionActions,
  DatosFacturacionState,
  InitialState,
} from './types'

const DatosFacturacionClienteReducer = (
  state: DatosFacturacionState = InitialState,
  action: DatosFacturacionActions
): DatosFacturacionState => {
  switch (action.type) {
    case SHOW_PAGE_DATOS_FACTURACION: {
      return {
        ...state,
        validRoute: true,
      }
    }

    case HIDE_PAGE_DATOS_FACTURACION: {
      return {
        ...state,
        validRoute: false,
      }
    }

    default:
      return state
  }
}

export default DatosFacturacionClienteReducer
